module.exports = __webpack_public_path__ + "img/LaBase-Waikiki-600px.5dd46783.jpg";